import { render, staticRenderFns } from "./SourceDeleteDialog.vue?vue&type=template&id=ea23102a&"
import script from "./SourceDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./SourceDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports